<button mat-icon-button class="labeled-actions-buttons" *ngIf="process && process.isRestartSupported"
    [disabled]="!process.canRestart" (click)="configureProcess($event)">
    <mat-icon matTooltip="Configure">
        edit
    </mat-icon>
    <span>{{label}}</span>
</button>
